import { useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { HiOutlineCurrencyDollar } from "react-icons/hi";
import { Drawer, Tooltip, Typography, message } from "antd";
import api from "../../services/api";
import { isMobile } from "../../utils";
import { NotificationContainer } from "./styles";
import { useClients } from "../../contexts/ClientsContext";
import notificationImage from "../../assets/notification.png";
import { ReactComponent as SendIcon } from "../../assets/icons/send.svg";

interface IProps {
  open: boolean;
  onClose:
    | ((
        e: React.MouseEvent<Element, MouseEvent> | React.KeyboardEvent<Element>
      ) => void)
    | undefined;
  filters: any;
  searchText: string;
  currentPage: number;
}

export const NotificationDrawer = ({ open, onClose, filters, searchText, currentPage }: IProps) => {
  const {
    selectedClient,
    notificacoes,
    setNotificacoes,
    loadingNotificacoes,
    getClients,
  } = useClients();
  const [loadingIndex, setLoadingIndex] = useState<number | "all" | null>(null);
  const lidas = (notificacoes || []).filter((n) => n.viewed);
  const naoLidas = (notificacoes || []).filter((n) => !n.viewed);

  const removeNotification = (index?: number) => {
    const notifications = notificacoes.map((n, i: number) => {
      if (index === undefined || index === i)
        return { ...n, viewed: true, viewedDate: new Date() };
      return n;
    });

    setLoadingIndex(index === undefined ? "all" : index);
    api
      .patch(`/clients/notification/${selectedClient?.username}`, {
        notifications,
      })
      .then(() => {
        setNotificacoes(notifications);
        setLoadingIndex(null);
        getClients({
          ...filters,
          page: currentPage,
          searchText: searchText.length > 0 ? searchText : null,
        });
      })
      .catch(() => {
        message.error("Não foi possível remover notificação");
      });
  };

  const sendWhatsapp = (event: any, phone: string, text: string) => {
    event.stopPropagation();
    const url = `https://wa.me${
      phone ? `/55${phone}` : ""
    }?text=${text.replaceAll(" ", "%20")}`;
    window.open(url, isMobile() ? undefined : "_blank");
  };

  return (
    <Drawer
      open={open}
      size="large"
      placement="right"
      onClose={onClose}
      closeIcon={<AiOutlineArrowLeft />}
      title={
        <div onClick={onClose} style={{ cursor: "pointer" }}>
          Voltar
        </div>
      }
      {...(isMobile() ? { width: "100%" } : {})}
    >
      <NotificationContainer>
        <div>
          <Typography.Title level={3}>Notificações</Typography.Title>
          <div className="divider" />
        </div>

        {(loadingNotificacoes || !notificacoes.length) && (
          <div className="illustration">
            <img src={notificationImage} alt="Notificações" />
            {loadingNotificacoes ? (
              <div className="loading">
                <LoadingOutlined />
                <Typography.Title level={5}>
                  Buscando notificações
                </Typography.Title>
              </div>
            ) : !notificacoes?.length ? (
              <Typography.Title level={5}>
                O seu cliente não possui novas notificações.
              </Typography.Title>
            ) : (
              <></>
            )}
          </div>
        )}

        {}
        {!!naoLidas?.length && !loadingNotificacoes && (
          <div className="section">
            <Typography.Title level={5}>Não lidas</Typography.Title>
            <button onClick={() => removeNotification()}>
              Marcar todas como lida
            </button>
          </div>
        )}
        {!loadingNotificacoes &&
          (notificacoes || [])?.map((item, i) => {
            if (item.viewed) return <></>;
            return (
              <div key={i}>
                <div
                  className="card"
                  onClick={() => {
                    if (!(loadingIndex === i || loadingIndex === "all"))
                      removeNotification(i);
                  }}
                >
                  {(loadingIndex === i || loadingIndex === "all") && (
                    <div className="loading">
                      <LoadingOutlined />
                    </div>
                  )}
                  <div className="header">
                    <HiOutlineCurrencyDollar />
                    <Typography.Title level={5}>
                      Rendimentos a receber
                    </Typography.Title>
                    {item?.date && (
                      <Typography.Text>
                        {new Date(item?.date)?.toLocaleDateString("pt-BR", {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                        })}
                      </Typography.Text>
                    )}
                  </div>
                  <div className="body">
                    <Typography.Text>{item.message}</Typography.Text>
                    <Tooltip title="Enviar por Whatsapp" placement="left">
                      <button
                        onClick={(e) => {
                          sendWhatsapp(e, selectedClient?.phone!, item.message);
                        }}
                      >
                        <SendIcon />
                      </button>
                    </Tooltip>
                  </div>
                </div>
              </div>
            );
          })}

        {/* Notificações Lidas */}
        {!!lidas?.length && !loadingNotificacoes && (
          <div className="section">
            <Typography.Title level={5}>Lidas</Typography.Title>
          </div>
        )}
        {!loadingNotificacoes &&
          (notificacoes || [])?.map((item, i) => {
            if (!item.viewed) return <></>;
            return (
              <div key={i}>
                <div className="card viewed">
                  <div className="header">
                    <HiOutlineCurrencyDollar />
                    <Typography.Title level={5}>
                      Rendimentos a receber
                    </Typography.Title>
                    {item?.date && (
                      <Typography.Text>
                        {new Date(item?.date)?.toLocaleDateString("pt-BR", {
                          year: "numeric",
                          month: "2-digit",
                          day: "2-digit",
                        })}
                      </Typography.Text>
                    )}
                  </div>
                  <div className="body">
                    <Typography.Text>{item.message}</Typography.Text>
                  </div>
                </div>
              </div>
            );
          })}
      </NotificationContainer>
    </Drawer>
  );
};
